import React from 'react';
import { Card } from '@/components/ui';
import type { AuditLogItem } from '../../types/dashboard.types';

interface RecentLogsWidgetProps {
  logs: AuditLogItem[];
}

export function RecentLogsWidget({ logs }: RecentLogsWidgetProps) {
  return (
    <Card className="p-6 border-slate-100 shadow-sm flex flex-col h-[280px]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-slate-900">Nhật ký hệ thống</h3>
        <button className="sm:text-sm text-xs font-medium text-emerald-600 hover:text-emerald-700">Xem tất cả</button>
      </div>

      <div className="flex-1 flex flex-col justify-center gap-4">
        {logs.map((log, index) => (
          <div key={index} className="flex items-start justify-between">
            <div className="flex items-start gap-3">
              <i className={`ri-file-list-3-line mt-0.5 ${
                log.type === 'danger' ? 'text-red-500' : 
                log.type === 'success' ? 'text-emerald-500' : 'text-slate-400'
              }`} />
              <span className="sm:text-sm text-xs font-medium text-slate-700 line-clamp-1">{log.action}</span>
            </div>
            <span className="sm:text-sm text-xs text-slate-400 whitespace-nowrap ml-4 font-mono">{log.created_at}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
